export default "__VITE_ASSET__B0XPk$ld__"